import { Avatar, Box } from "@mui/material";
import { type GridRenderCellParams } from "@mui/x-data-grid";
import { useMemo, type FC } from "react";
import { useUserOptions } from "../../useUserOptions";

export const UserDisplay: FC<GridRenderCellParams> = params => {
  const userOptions = useUserOptions();
  const user = useMemo(() => userOptions.find(option => option.value == params.value), [params.value, userOptions]);
  return (
    <Box display="flex" alignItems="center">
      {user?.avatar && (
      <Avatar src={user.avatar} sx={{ width: 32, height: 32 }} />
      )}
      <Box ml={1}>{user ? user.title : params.value}</Box>
    </Box>
  );
};
